import { Controller } from "@hotwired/stimulus"

// Bulk-select for the console resource index: a select-all header checkbox, a live
// "N selected" count, and a bulk action bar that reveals once anything is checked. The
// row checkboxes submit to the bulk form via their `form="admin_bulk_form"` attribute, so
// no nesting is needed — this controller only manages selection state + visibility.
export default class extends Controller {
  static targets = ["checkbox", "count", "bar"]

  toggleAll(event) {
    this.checkboxTargets.forEach((cb) => { cb.checked = event.target.checked })
    this.refresh()
  }

  refresh() {
    const n = this.checkboxTargets.filter((cb) => cb.checked).length
    if (this.hasCountTarget) this.countTarget.textContent = n
    if (this.hasBarTarget) {
      this.barTarget.classList.toggle("hidden", n === 0)
      this.barTarget.classList.toggle("flex", n > 0)
    }
  }
}
